<template>
  <div class="game">
    <div id="head-page" class="globulo parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
        <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page fiche-jeu">
      <div class="grid-x grid-margin-x">
        <div class="small-12 cell">
          <title-page attrpage="Mini jeux" baseline="À toi de jouer !">Chimiothérapie</title-page>

          <p>La plupart du temps, la chimiothérapie est une préparation liquide de médicament que l’on va faire passer dans ton sang pour te soigner grâce à une perfusion. La perfusion relie par un tuyau une petite aiguille plantée dans ta veine, appelée cathéter, à une poche contenant le médicament.</p>

          <p>La perfusion est posée le plus souvent à l’hôpital. Des moyens existent pour ne pas avoir mal quand on pique ta veine comme la crème anesthésiante par exemple.</p>

          <p>Pour mieux comprendre comment ça va se passer et t’aider à passer le temps pendant ta séance de chimiothérapie, tu peux :</p>
          <p>
            <ul>
              <li>Jouer au mini-jeu Chimiothérapie en aidant Globulo à préparer ton traitement. Pour cela il faut remplir la poche contenant ton médicament en alignant le plus de gélules en un temps donné. Lance le jeu pour voir !</li>
              <li>Consulter les ressources complémentaires ci-dessous.</li>
              <li>Poser des questions à ta Globulo Team de soignants et aussi à tes parents qui ont des informations sur ce soin.</li>
            </ul>

          </p>
          <div> <bouton href="/chimio/index.html">Accéder au jeu</bouton></div>

          <div class="grid-x grid-margin-x">
            <div class="small-12 cell">
              <h3>Les ressources complémentaires</h3>
            </div>

            <div class="small-12 medium-6 large-4 cell">
              <item-fiche lien="https://www.sparadrap.org/enfants/piqures/la-perfusion"  titlebox="La perfusion, fiche illustrée Sparadrap " type-item="article">Document illustré pour expliquer aux enfants à quoi sert la perfusion et comment elle se déroule.</item-fiche>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton.vue'
  import ItemFiche from '@/components/ItemFiche'
  export default {
    props: ['gameId'],
    components: { TitlePage, Bouton, ItemFiche },
  }

</script>
